<template>
  <v-wait for="so-kayit-inserting">
    <template slot="waiting">
      <div class="vue-wait-class">
        <img src="static/loading.svg" />
        <p>İşlem yapılıyor...</p>
      </div>
    </template>
    <div class="container">
      <div class="py-3 text-center">
        <h2>Saha Operasyon Kayıt Formu</h2>
        <p class="lead">Sahada yapılan işlem bilgilerini aşağıda ilgili yerlere yazarak kayıt yapabilirsiniz.</p>
      </div>
      <div class="row">
        <!--<div class="col-md-4 order-md-2 mb-4">
          <h4 class="d-flex justify-content-between align-items-center mb-3">
            <span class="text-muted">Kayıt Önizlemesi</span>
            <span class="badge badge-secondary badge-pill">{{gotPieceCount}}</span>
          </h4>
          <label class="transparent-label" for="">Boş Label</label>
          <ul class="list-group mb-3">
            <li class="list-group-item d-flex justify-content-between lh-condensed">
              <div>
                <h6 class="my-0">{{deviceId}}</h6>
                <label v-if="deviceId" class="switch text-right">
                  <input type="checkbox" v-model="deviceInWarrantyPeriod">
                  <span class="slider round"></span>
                </label>
                <small class="text-muted">{{deviceModel}}</small>
                <small v-if="deviceId" v-bind:class="{'text-success': deviceInWarrantyPeriod == 0, 'text-danger': deviceInWarrantyPeriod == 1}">
                  {{deviceInWarrantyPeriod == 0 ? "Ürün garantisi devam ediyor" : "Ürün garanti dışı"}}
                </small>
              </div>
            </li>
            <li v-for="equip in equipments" :key="equip.PieceId" class="list-group-item d-flex justify-content-between lh-condensed">
              <div>
                <h6 class="my-0">{{equip.PieceName}}</h6>
                <label class="switch text-right">
                  <input type="checkbox" v-model="equip.Status">
                  <span class="slider round"></span>
                </label>
                <small v-bind:class="{'text-success': equip.Status == 0, 'text-danger': equip.Status == 1}">{{equip.Status == 0 ? "Ekipman sağlıklı durumda" : "Ekipman arızalı"}}</small>
              </div>
            </li>
          </ul>
          <div class="mb-3"></div>
          <button class="btn btn-block btn-primary" @click="insertArizaKaydi">Kaydı Tamamla</button>
        </div>-->
        <div class="col-md-12 order-md-1">
          <h4 class="mb-3">İşlem Bilgileri</h4>
          <div class="row">
            <div class="col-md-4 mb-3">
              <label for="firstName">İşlem Tarihi</label>
              <datepicker :bootstrap-styling="true" v-model="oper.OperDate" :format="dateFormatter"></datepicker>
              <!--<input type="text" class="form-control date-input" id="firstName" placeholder="" value="" required>-->
              <div class="invalid-feedback">
                Valid first name is required.
              </div>
            </div>
            <div class="col-md-4 mb-3">
              <label for="lastName">Cihaz Seri Numarası</label>
              <input type="text" class="form-control" :disabled="procStatus == 1" v-bind:class="{'loading' : procStatus == 1}"
                @keyup.enter="getDeviceInfo" v-model="oper.OperDeviceId" id="lastName" placeholder="Cihaz Seri Numarası" value="" maxlength="15" required>
              <div class="invalid-feedback">
                Valid last name is required.
              </div>
            </div>
            <div class="col-md-4 mb-3">
              <label for="operType">Yapılan İşlem Türü</label>
              <select class="custom-select mr-sm-2" id="operType" v-model="oper.OperType">
                <option value="" selected>Seçiniz...</option>
                <option value="MONTAJ (Tam Set)">MONTAJ (Tam Set)</option>
                <option value="MONTAJ (Cihaz)">MONTAJ (Cihaz)</option>
                <option value="DEMONTAJ (Tam Set)">DEMONTAJ (Tam Set)</option>
                <option value="DEMONTAJ (Cihaz)">DEMONTAJ (Cihaz)</option>
                <option value="DEĞİŞİM">CİHAZ DEĞİŞİMİ</option>
                <option value="SERVİS HİZMETİ">SERVİS HİZMETİ</option>
              </select>
              <div class="invalid-feedback">
                Valid last name is required.
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="customerTitle">Müşteri Adı</label>
              <input type="text" class="form-control" disabled :value="customerTitle" id="customerTitle" placeholder="" required>
              <div class="invalid-feedback">
                Valid last name is required.
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <label for="vehicleName">Araç Plakası</label>
              <input type="text" class="form-control" id="vehicleName"
                :disabled="procStatus == 1" v-bind:class="{'loading' : procStatus == 1}"
                @keyup.enter="getDeviceInfo" placeholder="" v-model="vehicleName" required>
              <div class="invalid-feedback">
                Valid last name is required.
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 mb-3">
              <label for="customer-address">Montaj Noktası</label>
              <autocomplete id="customer-address" :inputClass="'loading'"
                v-model="oper.OperPoint"
                :serializer="item => item.CompanyName" :data="servicePoints" placeholder="Montaj Noktası"
                @hit="selectedServicePoint = $event" />
              <!--<input type="text" class="form-control" id="customer-address" placeholder="" v-model="oper.OperPoint"/>-->
            </div>
            <div class="col-md-4 mb-3">
              <label for="sender-address">İşin Yapıldığı Şehir</label>
              <input type="text" class="form-control" id="sender-address" placeholder="" v-model="oper.OperCity" />
            </div>
            <div class="col-md-4 mb-3">
              <label for="oper-amount">İşin Tutarı</label>
              <div class="input-group">
                <input type="text" class="form-control" id="oper-amount" placeholder="" v-model="oper.OperAmount" />
                <div class="input-group-append">
                  <span class="input-group-text" id="basic-addon1">Türk Lirası</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 mb-3">
              <label for="gsm-no">GSM Numarası</label>
              <input type="text" class="form-control" id="gsm-no" placeholder="GSM Numarası" v-model="oper.OperGsmNo"/>
            </div>
            <div class="col-md-4 mb-3">
              <label for="last-device-id">Son Cihaz Seri Numarası</label>
              <input type="text" class="form-control" id="last-device-id" placeholder="Son Cihaz Seri No" v-model="oper.OperLastDeviceId"/>
            </div>
            <div class="col-md-4 mb-3">
              <label for="last-vehicle-name">Son Araç Plakası</label>
              <input type="text" class="form-control" id="last-vehicle-name" placeholder="Son Araç Plakası" v-model="oper.OperLastVehicleName"/>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <label for="sender-name">Montaj Noktası Faturası</label>
              <input type="text" class="form-control" id="sender-name"
                v-model="oper.OperInvoicePoint" placeholder="Montaj Noktası Faturası">
            </div>
            <div class="col-md-6">
              <label for="incoming-document-code">Lenoi Faturası</label>
              <input type="text" class="form-control" id="incoming-document-code"
                v-model="oper.OperInvoiceLenoi" placeholder="Lenoi Faturası">
            </div>
          </div>
          <div class="mb-3">
            <label for="ariza-note">Yapılan İşlem Notu</label>
            <textarea class="form-control" id="ariza-note" rows="5" placeholder="İşlem Notu" v-model="oper.OperNote" required></textarea>
          </div>
          <button class="btn btn-primary btn-lg btn-block" @click="insertArizaKaydi()">Kaydı Tamamla</button>
        </div>
      </div>
      <div class="mb-4"></div>
    </div>
  </v-wait>
</template>

<script>
/* eslint-disable */

import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import axios from 'axios'
import autocompl from 'vue-bootstrap-typeahead'

export default {
  name: 'SOKayitEkle',
  components: {
    'datepicker': Datepicker,
    'autocomplete': autocompl,
  },
  data () {
    return {
      procStatus: 0,
      customerTitle: '',
      vehicleName: '',
      servicePoints: [],
      selectedServicePoint: {},
      oper: {
        SessionId: "",
        OperId: 0,
        OperDate: "",
        OperDeviceId: "",
        OperCity: "",
        OperType: "",
        OperPoint: "",
        OperInvoiceLenoi: "",
        OperInvoicePoint: "",
        OperGsmNo: "",
        OperLastDeviceId: "",
        OperLastVehicleName: "",
        OperNote: "",
        OperAmount: 0,
        OperVehicleName: ""
      },
      toastOptions: {
        theme: "bubble",
        position: "top-center",
        duration : 4000
      }
    }
  },
  computed: {
    getSessionId: function() { return this.$store.getters.getSessionId }
  },
  methods: {
    getServicePoints() {
      axios.post("/api/sahaoperasyon/montaj-noktalari?SessionId="+ this.getSessionId)
      .then(response => {
        this.servicePoints = response.data;
      })
    },
    getSOKayit() {
      if(this.$route.params.id === undefined)
        return

      this.$wait.start('so-kayit-inserting')

      axios.post("/api/sahaoperasyon/get-single?SessionId="+ this.getSessionId + "&OperId=" + this.$route.params.id)
      .then(response => {
        let single = response.data[0]
        this.oper.OperId = single.OPER_ID
        this.oper.OperDate = single.OPER_DATE
        this.oper.OperDeviceId = single.OPER_DEVICE_ID
        this.oper.OperCity = single.OPER_CITY
        this.oper.OperPoint = single.OPER_POINT
        this.oper.OperVehicleName = single.VEHICLE_NAME
        this.oper.OperCustomer = single.CUSTOMER_TITLE
        this.oper.OperType = single.OPER_TYPE
        this.oper.OperAmount = single.OPER_AMOUNT
        this.oper.OperLastDeviceId = single.OPER_LAST_DEVICE_ID
        this.oper.OperLastVehicleName = single.OPER_LAST_VEHICLE_NAME
        this.oper.OperInvoiceLenoi = single.OPER_INVOICE_LENOI
        this.oper.OperInvoicePoint = single.OPER_INVOICE_POINT
        this.oper.OperNote = single.OPER_NOTE
        this.OperGsmNo = single.OperGsmNo
        this.vehicleName = single.VEHICLE_NAME
        this.customerTitle = single.CUSTOMER_TITLE

        this.selectedServicePoint.CityName = single.OPER_CITY
        this.selectedServicePoint.CompanyName = single.OPER_POINT
        this.$wait.end('so-kayit-inserting')
      })
      .catch(err => this.$wait.end('so-kayit-inserting'))
    },
    insertArizaKaydi() {
      if(!this.oper.OperDate || !this.oper.OperDeviceId) {
        alert('Kayıt işlemini tamamlayabilmeniz için işlem tarihini ve cihaz seri numarasını doğru bir şekilde girmeniz gerekiyor.')
        return
      }

      this.$wait.start('so-kayit-inserting')
      this.oper.SessionId = this.getSessionId
      this.oper.OperId = this.$route.params.id || 0
      this.oper.OperCity = this.selectedServicePoint.CityName || this.oper.OperCity
      this.oper.OperPoint = this.selectedServicePoint.CompanyName || this.oper.OperPoint
      this.oper.OperDate = moment(this.oper.OperDate).format('DD.MM.YYYY')
      console.log(this.oper)

      axios.post("/api/sahaoperasyon/kayit-ekle", this.oper)
      .then(response => {
        if(response.data.HasError == false) {
          this.$router.push('/saha-operasyon')
          this.$toasted.success('İşlem kaydı oluşturuldu !', this.toastOptions)      
        }
        else {
          this.$toasted.error('Kayıt oluşturulamadı. Durum mesajı: ' + response.data.ErrorMessage, this.toastOptions)      
        }

        this.$wait.end('so-kayit-inserting')
      })
    }, 
    dateFormatter(date) {
      return moment(date).format('DD.MM.YYYY')
    },
    getDeviceInfo(e) {
      this.procStatus = 1
      e.preventDefault()
      axios
      .post('/api/device/deviceInformation', 
        { "SessionId": this.getSessionId, "DeviceId": this.oper.OperDeviceId, "VehicleName": this.vehicleName })
      .then(response => {
        this.customerTitle = response.data.customerTitle
        this.vehicleName = response.data.vehicleName
        this.deviceModel = response.data.deviceModel
        this.customerAddress = response.data.customerAddress
        this.oper.OperDeviceId = response.data.deviceId
        this.procStatus = 0
      })
      .catch(error => { 
        console.log(error)
        this.procStatus = 0
      })
    }
  },
  mounted() {
    moment.locale('tr')
    console.log(this.oper)
    this.getServicePoints()
    this.getSOKayit()
    //this.arrivalDate = moment().format('L')
  }
}
</script>

<style scoped>
  
  .container {
    max-width: 960px;
  }
  .transparent-label { color: rgba(0,0,0,0);}
  .light-text { 
    font-weight: 400 !important; 
    -webkit-user-select: none; /* Safari */        
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+/Edge */
    user-select: none; /* Standard */
  }
  .lh-condensed { line-height: 1.25; } 

  /* The switch - the box around the slider */
.switch {
  position: absolute;
  display: inline-block;
  z-index: 1;
  right: 10px;
  top: 10px;
  width: 40px;
  height: 25px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #1DB954;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #F00;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 26px;
}

.slider.round:before {
  border-radius: 50%;
}

input[type="text"].loading {
  background-image: url("~/static/loading.svg");
  background-size: 32px 32px;
  background-position:right center;
  background-repeat: no-repeat;
}

  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  .vue-wait-class img {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }

  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }
</style>


// WEBPACK FOOTER //
// src/components/SOKayitEklePage.vue